import { createFileRoute } from '@tanstack/react-router';
import { ClientAdminPage } from '@/features/preparer/clients/ClientAdminPage';
import { z } from 'zod';
import { ConfidentialFilter } from '@ata-digital/client-tax-system-api-client';
import { userSettingQueryOptions } from '@/lib/query/options';

// Extract ConfidentialFilter enum values for Zod validation
const confidentialFilterValues = Object.values(ConfidentialFilter) as [ConfidentialFilter, ...ConfidentialFilter[]];

// Define search params schema for sticky filtering/sorting
const clientsSearchSchema = z
  .object({
    page: z.number().int().positive().optional().catch(undefined),
    rowsPerPage: z.number().int().positive().optional().catch(undefined),
    sortBy: z.string().optional().catch(undefined),
    sortOrder: z.enum(['asc', 'desc']).optional().catch(undefined),
    search: z.string().optional().catch(undefined),
    myClientsOnly: z.string().optional().catch(undefined), // 'true' or undefined
    binderStatus: z.enum(['has_open', 'all_completed', 'no_binders']).optional().catch(undefined),
    dateRangeStart: z.string().optional().catch(undefined), // Store dateRange as separate fields
    dateRangeEnd: z.string().optional().catch(undefined),
    type: z.string().optional().catch(undefined),
    state: z.string().optional().catch(undefined),
    officeIds: z.array(z.string()).optional().catch(undefined),
    partnerId: z.string().optional().catch(undefined), // Filter by partner
    tags: z.array(z.string()).optional().catch(undefined),
    createdAfter: z.string().optional().catch(undefined),
    createdBefore: z.string().optional().catch(undefined),
    confidentialFilter: z.enum(confidentialFilterValues).optional().catch(undefined),
  })
  .passthrough(); // Allow unknown keys to pass through

export const Route = createFileRoute('/preparer/clients/')({
  loader: async ({ context: { queryClient } }) => {
    const authState = queryClient.getQueryData(['auth', 'session']) as
      | { token?: string; isAuthenticated?: boolean }
      | undefined;

    if (authState?.token) {
      queryClient.prefetchQuery(userSettingQueryOptions.current(authState.token)).catch(() => {});
    }
  },
  component: ClientAdminPage,
  validateSearch: clientsSearchSchema,
});
